import { axiosInstance, axiosFileBlob } from "../instance";

// 点播节目统计获取主品牌
export const getVodMainAgentApi = (params) => {
    const { cid } = params;
    return axiosInstance({
        method: 'get',
        url: `/api/category/getVodMainAgent`,
        params: { cid },
        noRepetition: true,
    });
}

// 点播节目统计获取子品牌
export const getVodSubAgentApi = (params) => {
    const { mainAgentId } = params;
    return axiosInstance({
        method: 'get',
        url: `/api/category/getVodSubAgent`,
        params: { mainAgentId },
        noRepetition: true,
    });
}

// 获取点播节目统计语言的合并行
export const getLanguageTotalApi = (params) => {
    const { cid, time, mainAgentId, subAgentId, language, programType, type } = params;
    return axiosInstance({
        method: 'get',
        url: `/api/vod/getLanguageTotal`,
        params: { cid, time, mainAgentId, subAgentId, language, programType, type },
        noRepetition: true,
    });
}

// 获取点播节目统计列表数据
export const getProgramDataApi = (params) => {
    const { cid, time, mainAgentId, subAgentId, language, programType, type } = params;
    return axiosInstance({
        method: 'get',
        url: `/api/vod/getProgramData`,
        params: { cid, time, mainAgentId, subAgentId, language, programType, type },
        noRepetition: true,
    });
}

// 获取点播节目统计上下线数量
export const getOnlineOfflineCountApi = (params) => {
    const { cid, time, mainAgentId, subAgentId, language, programType } = params;
    return axiosInstance({
        method: 'get',
        url: `/api/vod/getOnlineOfflineCount`,
        params: { cid, time, mainAgentId, subAgentId, language, programType },
        noRepetition: true,
    });
}

// 获取点播节目统计视频总数
export const getVideoCountApi = (params) => {
    const { cid } = params;
    return axiosInstance({
        method: 'get',
        url: `/api/vod/getVideoCount`,
        params: { cid },
        noRepetition: true,
    });
}